export default (
  shipping_address,
  billing_address,
  totalPrice,
  success,
  cancel
) =>
  paypal.Button.render(
    {
      env: `${process.env.GATSBY_PAYPAL_APP_TYPE}`,
      client: {
        sandbox: `${process.env.GATSBY_PAYPAL_SANDBOX}`,
        production: `${process.env.GATSBY_PAYPAL_PRODUCTION}`
      },
      locale: 'de_CH',
      style: {
        label: 'checkout',
        size: 'small',
        shape: 'pill',
        color: 'blue'
      },

      commit: true,

      payment: (data, actions) => {
        const paymentinfo = {
          intent: 'sale',
          payer: {
            payment_method: 'paypal',
            payer_info: {
              first_name: billing_address.given_name,
              last_name: billing_address.family_name,
              billing_address: {
                line1:
                  billing_address.street + ' ' + billing_address.house_number,
                line2: '',
                city: billing_address.city,
                postal_code: billing_address.postal_code,
                country_code: 'CH',
                phone: billing_address.tel
              }
            }
          },
          transactions: [
            {
              amount: {
                total: totalPrice,
                currency: 'CHF',
                details: {
                  subtotal: totalPrice,
                  tax: '0.00',
                  shipping: '0.00',
                  handling_fee: '0.00',
                  shipping_discount: '0.00',
                  insurance: '0.00'
                }
              },
              description: 'Atelier Cartier Order',
              item_list: {
                shipping_address: {
                  recipient_name:
                    shipping_address.given_name +
                    ' ' +
                    shipping_address.family_name,
                  line1:
                    shipping_address.street +
                    ' ' +
                    shipping_address.house_number,
                  line2: '',
                  city: shipping_address.city,
                  postal_code: shipping_address.postal_code,
                  country_code: 'CH',
                  state: 'ZH',
                  phone: shipping_address.tel
                }
              }
            }
          ]
        }

        return actions.payment.create(paymentinfo)
      },

      onAuthorize: (data, actions) => actions.payment.execute().then(success),

      onCancel: data => cancel()
    },
    '#paypal-button'
  )
